export const colorClasses = {
  blue:
    'bg-blue border-blue text-white hover:bg-blue-600 hover:border-blue-600 hover:text-white ' +
    'dark:hover:bg-blue-500 dark:hover:border-blue-500 ' +
    'focus-visible:bg-blue-600 focus-visible:border-blue-600 focus-visible:text-white ' +
    'dark:focus-visible:bg-blue-500 dark:focus-visible:border-blue-500',
  blueBordered:
    'bg-white dark:bg-transparent border-blue text-blue dark:text-white hover:text-white ' +
    'hover:bg-blue dark:hover:bg-blue hover:border-blue focus-visible:text-white focus-visible:bg-blue ' +
    'dark:focus-visible:bg-blue focus-visible:border-blue',
  red:
    'bg-red-600 border-red-600 text-white hover:bg-red-700 hover:border-red-700 ' +
    'focus-visible:bg-red-700 focus-visible:border-red-700',
  redBordered:
    'bg-white dark:bg-transparent border-red-600 text-red-600 dark:text-white hover:text-white ' +
    'hover:bg-red-600 dark:hover:bg-red-600 hover:border-red-600 hover:text-white focus-visible:text-white ' +
    'focus-visible:bg-red-600 dark:focus-visible:bg-red-600 focus-visible:border-red-600',
  gray:
    'bg-slate-100 dark:bg-slate-700 border-slate-100 dark:border-slate-800 text-slate-900 dark:text-white ' +
    'hover:text-slate-900 hover:bg-slate-100 dark:hover:bg-slate-700 hover:border-slate-100 ' +
    'dark:hover:border-slate-800 focus-visible:text-slate-900 focus-visible:bg-slate-100 ' +
    'dark:focus-visible:bg-slate-700 focus-visible:border-slate-100 dark:focus-visible:border-slate-800',
  grayBordered:
    'bg-white dark:bg-transparent border-slate-200 text-slate-900 dark:text-white hover:text-slate-900 ' +
    'hover:bg-white dark:hover:text-white hover:border-blue focus-visible:text-slate-900 focus-visible:bg-white ' +
    'dark:hover:bg-transparent focus-visible:border-blue',
  borderless:
    'bg-transparent disabled:bg-transparent border-0 text-slate-900 dark:text-white hover:underline ' +
    'h-auto xl:h-auto hover:text-slate-900 dark:hover:text-white focus-visible:underline focus-visible:text-slate-900',
  borderlessBlue:
    'bg-transparent! border-0 text-blue dark:text-white hover:underline h-auto xl:h-auto ' +
    'hover:opacity-50 disabled:hover:opacity-100 focus-visible:underline focus-visible:opacity-50 ' +
    'disabled:focus-visible:opacity-100',
  green:
    'bg-lime-700 border-lime-700 text-white hover:bg-lime-800 hover:border-lime-800 hover:text-white ' +
    'dark:bg-lime-800 dark:border-lime-800 dark:text-white ' +
    'dark:hover:bg-lime-700 dark:hover:border-lime-700 ' +
    'focus-visible:bg-lime-800 focus-visible:border-lime-800 focus-visible:text-white ' +
    'dark:focus-visible:bg-lime-700 dark:focus-visible:border-lime-700',
  greenBordered:
    'bg-white dark:bg-transparent border-lime-600 text-lime-600 dark:border-lime-700 dark:text-white ' +
    'hover:text-white hover:bg-lime-600 hover:border-lime-600 ' +
    'dark:hover:bg-lime-700 dark:hover:border-lime-700 ' +
    'focus-visible:text-white focus-visible:bg-lime-700 focus-visible:border-lime-700 ' +
    'dark:focus-visible:bg-lime-700 dark:focus-visible:border-lime-700',
  orange:
    'bg-orange-300 border-orange-300 text-orange-700 hover:bg-orange-700 hover:border-orange-700 ' +
    'hover:text-white focus-visible:bg-orange-700 focus-visible:border-orange-700 focus-visible:text-white',
  transparent:
    'bg-transparent border-transparent hover:bg-blue-50 hover:border-blue-50 dark:hover:bg-slate-700 ' +
    'text-blue dark:text-white focus-visible:bg-blue-50 focus-visible:border-blue-50 ' +
    'dark:focus-visible:bg-slate-700',
  slateBordered:
    'bg-white dark:bg-transparent border-slate-400 text-slate-500 dark:border-slate-200 dark:text-slate-300 ' +
    'hover:bg-slate-100 dark:hover:bg-slate-800 focus-visible:bg-slate-100 dark:focus-visible:bg-slate-800',
};

export const sizeClasses = {
  sm: 'h-6 text-sm',
  base: 'h-7 xl:h-8 text-base',
  md: 'h-10 text-base',
  lg: 'h-12 text-lg',
};

export const shadowClasses = {
  none: '',
  sm: 'shadow-xs',
  base: 'shadow-md',
  lg: 'shadow-lg',
};

export const sizeIconClasses = {
  sm: 'min-w-3 w-3',
  base: 'min-w-3 w-3',
  md: 'min-w-4 w-4',
  lg: 'min-w-5 w-5',
};

export const paddingClasses = {
  sm: 'px-2',
  base: 'px-3',
  md: 'px-5',
  lg: 'px-6',
};

export const disabledClass =
  'bg-slate-200 dark:bg-slate-700 cursor-not-allowed text-slate-400 dark:text-slate-500 border-slate-200 ' +
  'dark:border-slate-700 hover:bg-slate-200 hover:border-slate-200 hover:text-slate-400 ' +
  'dark:hover:bg-slate-700 dark:hover:border-slate-700 dark:hover:text-slate-500 ' +
  'active:bg-slate-200 active:text-slate-400! focus:text-slate-400 ' +
  'dark:focus:text-slate-500 dark:active:text-slate-500!';

export const iconPositionClasses = {
  top: 'flex-col-reverse',
  bottom: 'flex-col',
  start: 'flex-row-reverse',
  end: 'flex-row',
};

export const iconPositionSpacingClasses = {
  start: 'mr-2',
  end: 'ml-2',
  top: '',
  bottom: '',
};

export const iconColorClasses = {
  inherit: 'text-inherit',
  blue: 'text-blue',
  black: 'text-slate-900',
  white: 'text-white',
  red: 'text-red',
};
